import axios from "../api/axios";
import useAuth from "./authenticate/useAuth";
// import { useNavigate } from "react-router-dom";

const useLogout = () => {
  const { auth, dispatch } = useAuth();
  // const navigate = useNavigate();

  const logout = async () => {
    try {
      await axios
        .post(`/v1/logout?token=${auth.token}`, {
          withCredentials: true,
        })
        .then((res) => {
          dispatch({ type: "SET_RESET", auth: null });
        });
    } catch (error) {
      console.error(error);
    }
  };
  return logout;
};
export default useLogout;
